import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "./api";

const FeatureCtx = createContext(null);

const DEFAULTS = {
  modules: {},
  tabs: {},
  sub_features: {},
  preset: "full",
  org_chart_template: "modern",
};

export function FeatureProvider({ children }) {
  const [flags, setFlags] = useState(DEFAULTS);
  const [loaded, setLoaded] = useState(false);

  const reload = useCallback(async () => {
    try {
      const r = await api.get("/feature-flags");
      setFlags({ ...DEFAULTS, ...r.data });
    } catch {
      // ignore (unauthenticated on login page)
    } finally {
      setLoaded(true);
    }
  }, []);

  useEffect(() => {
    if (localStorage.getItem("hreye_token")) reload();
    else setLoaded(true);
  }, [reload]);

  const isModuleOn = (k) => flags?.modules?.[k] !== false;
  const isTabOn = (module, tab) => flags?.tabs?.[module]?.[tab] !== false;
  const isSubOn = (module, sub) => flags?.sub_features?.[module]?.[sub] !== false;
  const orgChartTemplate = flags?.org_chart_template || "modern";

  return (
    <FeatureCtx.Provider value={{ flags, setFlags, reload, loaded, isModuleOn, isTabOn, isSubOn, orgChartTemplate }}>
      {children}
    </FeatureCtx.Provider>
  );
}

export const useFeatures = () => useContext(FeatureCtx) || { flags: DEFAULTS, isModuleOn: () => true, isTabOn: () => true, isSubOn: () => true, orgChartTemplate: "modern", loaded: true, reload: () => {} };
